import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck, ShieldAlert, AlertTriangle } from "lucide-react";

function Stat({ label, value, color, testid }) {
  return (
    <div>
      <div className="label-eyebrow">{label}</div>
      <div className="mt-1 font-display text-3xl" style={color ? { color } : {}} data-testid={testid}>{value}</div>
    </div>
  );
}

export default function TrustPanel() {
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/seller/trust").then((r) => setT(r.data)).catch(() => {}); }, []);
  if (!t) return null;
  const warn = t.strikes > 0 || t.suspended;

  return (
    <div data-testid="trust-panel" className="hairline p-6 mt-8"
      style={{ borderColor: warn ? "#EA580C" : "rgba(0,0,0,0.1)" }}>
      <div className="flex items-center gap-2">
        {warn ? <ShieldAlert size={15} style={{ color: "#EA580C" }} /> : <ShieldCheck size={15} style={{ color: "#16A34A" }} />}
        <span className="label-eyebrow" style={{ color: warn ? "#EA580C" : "#16A34A" }}>Seller trust</span>
      </div>
      <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-6">
        <Stat label="Trust score" value={t.score} color={t.score >= 70 ? "#16A34A" : "#EA580C"} testid="trust-score" />
        <Stat label="Verified listings" value={t.verified_listings} testid="trust-verified" />
        <Stat label="Strikes" value={`${t.strikes}/${t.strikes_to_suspend}`} color={t.strikes ? "#E11D48" : undefined} testid="trust-strikes" />
        <Stat label="Sales" value={t.sales} testid="trust-sales" />
      </div>
      {t.flagged_listings > 0 && (
        <p className="mt-4 text-xs" style={{ color: "#EA580C" }} data-testid="trust-flagged-note">
          {t.flagged_listings} listing{t.flagged_listings > 1 ? "s" : ""} could not be verified — they stay live with an
          “unverified” badge until better proof passes screening.
        </p>
      )}
      {t.suspended && (
        <p className="mt-4 flex items-start gap-2 text-xs" style={{ color: "#E11D48" }} data-testid="trust-suspended">
          <AlertTriangle size={13} className="mt-0.5 shrink-0" />
          Your selling privileges are suspended after {t.strikes} upheld counterfeit strikes. All your listings are hidden.
        </p>
      )}
      {!warn && (
        <p className="mt-4 text-xs text-neutral-500">
          Clean record. Verified authentic listings sell faster and raise this score — replicas must be disclosed.
        </p>
      )}
    </div>
  );
}
